import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import dataServices from "../../apiServices/data.services";
import Loader from "../../components/Loader/Loader";
import { handleValidationError, showAlert } from "../../components/CommonFunctions";
import { Can } from "../../context/AuthProvider";

const Payments = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const alert = useAlert();

  useEffect(() => {
    setLoading(true);
    dataServices
      .getPayments()
      .then((res) => {
        if (res.status === 200) {
          setPayments(res.data);
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      })
      .finally(() => setLoading(false));
  }, [alert]);

  const handleDelete = (id) => {
    dataServices
      .deletePayment(id)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setPayments(payments.filter((payment) => payment.id !== id));
          alert.success("Payment deleted successfully");
        }
      })
      .catch((err) => {
        alert.error(handleValidationError(err));
      });
  };

  return (
    <div className="content-wrapper">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="mb-2 pb-1 px-3 fw-bold text-black">Subscription Payments</h6>
        <Can I="add" this="Payment">
          <Link to="/add-payment" className="btn btn-primary">
            Add Payment
          </Link>
        </Can>
      </div>
      <Can I="list" this="Payment">
        <div className="list">
          {payments.length > 0 ? (
            payments.map((payment) => (
              <div className="list-item d-flex justify-content-between align-items-center" key={payment.id}>
                <div className="w-100">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <h6 className="mb-1 fs-14">Payment #{payment.id}</h6>
                      <small className="text-muted">Subscription: {payment.subscription?.id || payment.subscription_id || "N/A"}</small>
                      <br />
                      <strong>Amount:</strong> ₹{payment.amount || "0.00"} | <strong>Date:</strong> {payment.payment_date || "N/A"}
                    </div>
                    <small className={`badge ${payment.status === "successful" || payment.status === "completed" ? "bg-success" : "bg-secondary"}`}>
                      {payment.status || "unknown"}
                    </small>
                  </div>
                  <div className="mt-2 d-flex gap-2">
                    <Can I="read" this="Payment">
                      <Link className="btn btn-sm btn-outline-info" to={`/payment/${payment.id}`}>
                        Details
                      </Link>
                    </Can>
                    <Can I="edit" this="Payment">
                      <Link className="btn btn-sm btn-outline-primary" to={`/edit-payment/${payment.id}`}>
                        Edit
                      </Link>
                    </Can>
                    <Can I="delete" this="Payment">
                      <button className="btn btn-sm btn-outline-danger" onClick={() => showAlert("Payment", handleDelete, payment.id)}>
                        Delete
                      </button>
                    </Can>
                  </div>
                </div>
              </div>
            ))
          ) : loading ? (
            <Loader />
          ) : (
            <p className="px-3">No payments found.</p>
          )}
        </div>
      </Can>
    </div>
  );
};

export default Payments;
